import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@ohif/ui';

import './LoadingIndicatorProgress.css';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { ProgressService } from '../../service/ProgressService';

/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */
function LoadingIndicatorProgress({ className, textBlock }) {

  const [startGetProgress, setStartGetProgress] = useState(false);
  const [value, setValue] = useState<number>(0);
  const [isViewerImageDicom, setIsViewerImageDicom] = useState(false);

  const progressService = new ProgressService();

  const StartProgressDownload = () => {
    let count = value + 1;
    let checkResponse = 0;
    const interval = setInterval(() => {
      const studyInstanceUid = window.location.search.replace("?StudyInstanceUIDs=", "");
      if (studyInstanceUid) {
        const cornerstoneViewportElement = document.getElementsByClassName('cornerstone-viewport-element').length > 0;
        if (checkResponse >= 20 || cornerstoneViewportElement) { // Para evitar ficar dando get em caso de não obter resposta do servidor
          setValue(0);
          clearInterval(interval);
        }
        progressService.GetProgress(studyInstanceUid)
          .then(resp => {
            count = resp.data;
            if (count >= 100 || count === -1) {
              setValue(0);
              clearInterval(interval);
              checkResponse = 20;
            }
            setValue(count);
          })
          .catch(error => {
            clearInterval(interval);
            checkResponse = 20;
            return;
          });
        checkResponse++;
      }
    }, 2000);
  };

  const validarUrl = () => {
    const _isViewerImageDicom = window.location.search.includes("StudyInstanceUIDs");
    setIsViewerImageDicom(_isViewerImageDicom);
  }

  useEffect(() => {
    validarUrl();
    if (!isViewerImageDicom)
      return;
    if (!startGetProgress) {
      setStartGetProgress(true);
      StartProgressDownload();
    }
  }, [startGetProgress, isViewerImageDicom]);

  return (
    <div
      className={classNames(
        'absolute z-50 top-0 left-0 flex flex-col items-center justify-center space-y-5',
        className
      )}
    >
      <img src="/layout/logo.png" alt="" style={{ maxHeight: '40px' }} />
      <div className="loading" style={{ height: 'auto', width: '20em' }}>
        <ProgressBar mode={value == 0 ? 'indeterminate' : 'determinate'} value={value} style={{ height: '30px' }}></ProgressBar>
        <div style={{ backgroundColor: '#040d19', textAlign: 'center', color: '#8dd0ff', padding: '5px', fontSize: '12px' }}>
          {!isViewerImageDicom ? "Aguarde..." : value < 100 ? "Aguarde. Obtendo imagens dicom..." : "Aguarde. Finalizando..."}
        </div>
      </div>
      {/* <div style={{ display: 'table-row' }}>
        <div className="loading">
          <div className="infinite-loading-bar bg-primary-light"></div>
        </div>
        <div style={{ textAlign: 'center', marginTop: '10px' }}>{progress}</div>
      </div> */}
      {/* <div className="loading">
        {progress === undefined || progress === null ? (
          <div className="infinite-loading-bar bg-primary-light"></div>
        ) : (
          <div
            className="bg-primary-light"
            style={{
              width: `${progress}%`,
              height: '8px',
            }}
          ></div>
        )}
      </div> */}
      {textBlock}
    </div>
  );
}

export default LoadingIndicatorProgress;
